var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"update-info-item",style:(_vm.styles),on:{"click":function($event){_vm.clickinfo(_vm.idx)}}},[_c('h4',{staticClass:"update-title"},[_vm._v(_vm._s(_vm.updateList.title))]),_vm._v(" "),_c('p',{staticClass:"update-desc",domProps:{"innerHTML":_vm._s(_vm.updateList.desc)}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af9f5cac","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/UpdateInfoItem.vue
// module id = null
// module chunks = 